module.exports = __webpack_public_path__ + "static/media/photo186.d526ecfc.jpg";